import { InlineEditField, type InlineEditFieldProps } from '@exam-management/components';

import { useEditingField } from '../../hooks';
import { useQConfigStructureFormContext } from '../../providers';

const UNSAVED_CHANGES_ERROR_MESSAGE = 'กรุณาบันทึกการเปลี่ยนแปลงก่อนดำเนินการต่อ';

export interface StructureNameInputProps extends InlineEditFieldProps {
  id?: string;
}

export default function StructureNameInput(props: Readonly<StructureNameInputProps>) {
  const { name } = props;
  const formContext = useQConfigStructureFormContext();
  const editingFields = useEditingField();

  const handleClickOutside = () => {
    formContext.setError(name, {
      type: 'onBlur',
      message: UNSAVED_CHANGES_ERROR_MESSAGE,
    });
  };

  const focusPreviousField = () => {
    const previousField = editingFields.data.values().next().value;
    if (previousField) {
      const input = document.getElementsByName(previousField)[0] as HTMLInputElement;
      if (input) {
        input.focus();
        formContext.setError(previousField, {
          type: 'onBlur',
          message: UNSAVED_CHANGES_ERROR_MESSAGE,
        });
      }
    }
  };

  return (
    <InlineEditField
      onChangeMode={async (mode) => {
        if (mode === 'DISPLAY') {
          editingFields.handler.removeField(name);
          formContext.clearErrors(name);
        } else if (editingFields.data.size === 0) {
          editingFields.handler.addField(name);
        } else {
          focusPreviousField();
          return Promise.reject(new Error('prevent mode change since there is editing field'));
        }
      }}
      onClickOutside={handleClickOutside}
      {...props}
    />
  );
}
